import { TradePair } from '../../../../context/chart/chartTypes';
import { formatUSD } from '../../../../helpers';

type EstimatedPnlProps = {
    trigger: string;
    amount: string;
    pnl: string;
    pool: TradePair | undefined;
};

const EstimatedPnl: React.FC<EstimatedPnlProps> = ({ trigger, amount, pnl, pool }) => {
    return (
        <p>
            When Mark Price reaches{' '}
            {amount
                ? formatUSD(amount, {
                      currency: '',
                      minDecimals: 2,
                      maxDecimals: pool?.decimalFormatting || 2,
                  })
                : '--'}{' '}
            USD, it will trigger {trigger} order to close this position. Estimated PnL
            will be{' '}
            {amount ? (
                <span className={+pnl > 0 ? 'increased' : 'decreased'}>
                    {formatUSD(pnl, {
                        currency: '',
                    })}
                </span>
            ) : (
                '--'
            )}{' '}
            USD
        </p>
    );
};

export default EstimatedPnl;
